import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/Subscription";

export const SUBSCRIPTION_PREFIX_URL = PREFIX_URL;

/**
 * CompanySettings abonelik remote ID kaydı.
 * @param {{ query?: object, params?: object }} [options]
 */
export const SubscriptionRegister = (options) =>
  GENERATE_URL(`${PREFIX_URL}/SubscriptionRegister`, options);

/**
 * CompanySettings abonelik bağlantı bilgisi.
 * @param {{ query?: object, params?: object }} [options]
 */
export const GetSubscriptionInfo = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetSubscriptionInfo`, options);

export default {
  SubscriptionRegister,
  GetSubscriptionInfo,
};
